module.exports = __webpack_public_path__ + "static/img/yami-g.63a8e514.png";